export enum AppParams {
    CollateralMint = "collateral",
    Term = "term",
    BorrowLendRole = "role"
}

export enum PortfolioTab {
    Earn = "earn",
    LendVaults = "lend-vaults",
    Loans = "loans",
    Vaults = "vaults",
    Strategies = "positions",
    Orders = "offers",
    PrimeLenderLoans = "lender-loans",
    Requests = "requests",
    Activity = "activity",
    PastLoans = "past-loans",
    Syndicates = "syndicates"
}

export enum ManagerViewTabs {
    Detail = "detail",
    Collateral = "collateral",
    Rates = "rates",
    CollateralAllocation = "collateral-allocation",
    Settings = "settings",
    TimeLocks = "timelocks",
    Rewards = "rewards",
    PrincipalCaps = "principal-caps"
}
